import React from 'react'
import PropTypes from 'prop-types'
import { FieldWrapper, Select } from '@morningtrain/react-fields'
import { ModelContext } from '@morningtrain/react-resources'
import useDepartments from 'support/hooks/use-departments'
import useDepartment from 'support/hooks/use-department'
import useDepartmentId from 'support/hooks/use-department-id'
import { useTranslation } from '@morningtrain/react-translations'
import SelectedDepartmentFilter from 'support/filters/SelectedDepartmentFilter'
import { useWillOnlyConstrain } from '@morningtrain/react-filters'

function DepartmentFilter (props) {
  const [department] = useDepartment()
  const [defaultDepartmentId] = useDepartmentId()
  const [value, setValue] = React.useState(defaultDepartmentId)

  const [departments] = useDepartments()

  const options = departments.map((val, index) => {
    return {
      value: val.id,
      label: val.name
    }
  })

  useWillOnlyConstrain(props.name, value)

  const placeholder = useTranslation(props.withoutAllDepartments === true ? 'generic.select_department' : 'generic.all_departments')

  const handleChange = selectedValue => {
    if (props.withoutAllDepartments === true && !selectedValue) {
      return
    }
    setValue(selectedValue)
  }

  return (
    <ModelContext.Provider value={department}>
      {options.length > 1
        ? (
          <FieldWrapper>
            <Select
              placeholder={placeholder}
              name='id'
              className={props.className}
              options={options}
              naked
              onChange={handleChange}
            />
          </FieldWrapper>
          )
        : (
          <SelectedDepartmentFilter />
          )}
    </ModelContext.Provider>
  )
}

DepartmentFilter.defaultProps = {
  label: null,
  name: 'department',
  placeholder: null
}

DepartmentFilter.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  icon: PropTypes.node
}

export default DepartmentFilter
